import React, { Component, Fragment } from "react";
import { curdActions } from "../../reduxCURD/actions";
import { CRUDFunction } from "../../reduxCURD/container";
import { getAllInspectableAssets } from "../../reduxRelated/actions/assetHelperAction";
import momentTz from "moment-timezone";
import { Row, Col } from "reactstrap";
import Card from "../LampAssets/CardView/Card";
import SpinnerLoader from "../Common/SpinnerLoader";
import { getTestStatusDetails } from "./getTestStatusUtils";
import { generateWorkingDays } from "./calendarUtils";
import MenuFilter from "components/Common/MenuFilters/index";
import { CalendarPanel } from "./CalendarPanel";
import { dataFormatters } from "../../utils/dataFormatters";
import { ToastService } from "../../utils/toastify";
import "./styles.css";
import ConfirmationDialog from "../../libraries/ConfirmationDialog";
import ToggleButton from "../../libraries/ToggleButton";
import permissionCheck from "utils/permissionCheck.js";
export class PIScheduler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupedTests: {},
      assets: [],
      spinnerLoading: false,
      selectedAssetId: null,
      searchTerm: "",
      filterLocations: [],
      workingDays: generateWorkingDays(50),
      assetsAllowedPerDay: 0,
      weekDays: [],
      isChanged: false,
      mode: "View",
      confirmationDialog: null,
    };
    this.isAllowedToEdit = permissionCheck("PI", "edit");
    this.handleAssetView = this.handleAssetView.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
  }

  componentDidMount() {
    this.props.getAssetTests("/nonRemovedEnabledTests");
    this.props.getAllInspectableAssets();
    let codes = ["daysAllowedInPIView", "assetsAllowedPerDayPI", "offdays"];
    let url = `config/${codes.join(",")}`;
    this.props.getApplicationlookupss(url);
  }
  //Location issue: need to fetch lineid but with getAllInspectableAssets we cant fetch lineId of an asset
  componentDidUpdate(prevProps) {
    if (this.props.assetTestActionType === "ASSETTEST_UPDATE_REQUEST" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({ spinnerLoading: true });
    }
    if (this.props.assetTestActionType === "ASSETTEST_UPDATE_SUCCESS" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({ spinnerLoading: false });
      ToastService.Success("Updated PI Schedule Successfully");
      this.props.getAssetTests("/nonRemovedEnabledTests");
    }
    if (this.props.assetTestActionType === "ASSETTEST_UPDATE_FAILURE" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({ spinnerLoading: false });
    }
    if (this.props.assetTestActionType === "ASSETTESTS_READ_REQUEST" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({ spinnerLoading: true });
    }

    if (this.props.assetTestActionType === "ASSETTESTS_READ_SUCCESS" && prevProps.assetTestActionType !== this.props.assetTestActionType) {
      const assetTests = this.props.assetTests;
      if (!assetTests || assetTests.length === 0) {
        console.log("No asset tests found.");
      }
      const grouped = this.groupAssetTests(assetTests);
      this.setState({ groupedTests: grouped, spinnerLoading: false });
    }
    if (this.props.assetTestActionType === "ASSETTESTS_READ_FAILURE" && this.props.assetTestActionType !== prevProps.assetTestActionType) {
      this.setState({ spinnerLoading: false });
    }
    if (
      this.props.assetHelperActionType === "GET_ALLINSPECTABLE_ASSETS_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      const assets =
        this.props.allInspectableUserAssets && this.props.allInspectableUserAssets.assets ? this.props.allInspectableUserAssets.assets : [];
      this.setState({ assets, spinnerLoading: false });
    }
    if (
      this.props.assetHelperActionType === "GET_ALLINSPECTABLE_ASSETS_REQUEST" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({ spinnerLoading: true });
    }
    if (
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      let daysAllowedInPIView = this.props.applicationlookupss.find((l) => l.code === "daysAllowedInPIView");
      let assetsAllowedPerDayPI = this.props.applicationlookupss.find((l) => l.code === "assetsAllowedPerDayPI");
      let weekDays = this.props.applicationlookupss.find((l) => l.code === "offdays");

      this.setState({
        workingDays: generateWorkingDays(daysAllowedInPIView && daysAllowedInPIView.opt2),
        assetsAllowedPerDay: (assetsAllowedPerDayPI && assetsAllowedPerDayPI.opt2) || 100,
        weekDays: (weekDays && weekDays.opt2) || [],
      });
    }
  }
  openConfirmationDialog(title, message, confirmCallback, action, data) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
          additionalInfo={data}
        />
      ),
    });
  }
  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }
  handleAssetView(asset) {
    this.props.history && this.props.history.push(`/AssetView/${asset._id}`);
  }

  groupAssetTests(assetTests) {
    const grouped = {};
    if (!assetTests || !Array.isArray(assetTests)) {
      return grouped;
    }
    assetTests.forEach((test) => {
      const assetId = test.assetId;
      if (!assetId) return;
      if (!grouped[assetId]) {
        grouped[assetId] = [];
      }
      grouped[assetId].push(test);
    });
    return grouped;
  }
  getStatusPriority(status) {
    const priority = {
      overdue: 0,
      expiring: 1,
      due: 2,
    };
    if (priority[status] !== undefined) {
      return priority[status];
    }
    return 3;
  }
  createAssetIdNameMap(assetsList) {
    const mapping = {};
    assetsList.forEach((asset) => {
      mapping[asset._id] = asset.unitId;
    });
    return mapping;
  }
  getTimeValue(statusLine) {
    const match = statusLine && statusLine.match(/(\d+)d(?:\s+(\d+)h)?/);
    const days = match ? parseInt(match[1], 10) : 0;
    const hours = match && match[2] ? parseInt(match[2], 10) : 0;
    return days * 24 + hours;
  }
  getTestList(tests) {
    const testList = tests.map((test) => {
      const { status, statusLine1, statusLine2 } = getTestStatusDetails(test);
      let color = "#000";

      if (status === "overdue") color = "red";
      else if (status === "expiring") color = "orange";
      else if (status === "due") color = "black";
      return {
        name: test.title,
        status: status,
        statusLine1: statusLine1,
        statusLine2: statusLine2,
        statusColor: color,
      };
    });

    testList.sort((a, b) => {
      const priorityA = this.getStatusPriority(a.status);
      const priorityB = this.getStatusPriority(b.status);

      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      const timeA = this.getTimeValue(a.statusLine1);
      const timeB = this.getTimeValue(b.statusLine1);

      if (priorityA === 0) {
        return timeB - timeA; // overdue: later is worse
      }

      return timeA - timeB; // due/expiring: sooner is worse
    });

    return testList;
  }
  getAssetInfo(asset) {
    const attributes = asset.attributes || {};

    return [
      { name: "Asset Name", value: asset.unitId },
      { name: "Asset Type", value: asset.assetType },
      { name: "Location", value: asset.locationName || asset.location || "N/A" },
      { name: "Engine", value: attributes.Engine || "N/A" },
      { name: "Tier", value: attributes.Tier || "N/A" },
      { name: "Year Built", value: attributes["Year Built"] || "N/A" },
    ];
  }
  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };
  filterLocations = (locations) => {
    const selectedIds = locations.filter((loc) => loc.state).map((loc) => loc.id);
    this.setState({ filterLocations: selectedIds });
  };
  getAssetTestSummary(tests) {
    let highestPriority = 3;
    let timeValue = Number.MAX_SAFE_INTEGER;

    tests.forEach((test) => {
      const { status, statusLine1 } = getTestStatusDetails(test);
      const priority = this.getStatusPriority(status);

      if (priority < highestPriority) {
        highestPriority = priority;
        const time = this.getTimeValue(statusLine1);
        timeValue = time;
      } else if (priority === highestPriority) {
        const time = this.getTimeValue(statusLine1);
        if (priority === 0) {
          timeValue = Math.max(timeValue, time);
        } else {
          timeValue = Math.min(timeValue, time);
        }
      }
    });

    return { priority: highestPriority, timeValue };
  }
  getFilteredAssetIds() {
    const { groupedTests, assets, searchTerm, filterLocations } = this.state;

    return Object.keys(groupedTests).filter((assetId) => {
      const asset = assets.find((a) => a._id === assetId);
      if (!asset) return false;

      const matchesSearch = asset.unitId.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesLocation = filterLocations.includes(asset.lineId);

      return matchesSearch && matchesLocation;
    });
  }
  getSortedAssetIds(filteredAssetIds) {
    const { groupedTests } = this.state;
    return filteredAssetIds.slice().sort((idA, idB) => {
      const testsA = groupedTests[idA];
      const testsB = groupedTests[idB];
      const summaryA = this.getAssetTestSummary(testsA);
      const summaryB = this.getAssetTestSummary(testsB);

      if (summaryA.priority !== summaryB.priority) {
        return summaryA.priority - summaryB.priority;
      }
      if (summaryA.priority === 0) {
        return summaryB.timeValue - summaryA.timeValue;
      }
      return summaryA.timeValue - summaryB.timeValue;
    });
  }
  handleAssetSelect = (assetId) => {
    this.setState((prev) => ({
      selectedAssetId: prev.selectedAssetId === assetId ? null : assetId,
    }));
  };
  checkIfMoreAssetsCanBeAdded = (groupedTests, date, limit) => {
    let flatList = Object.values(groupedTests)
      .flat()
      .filter((l) => l.plannerInfo && Object.keys(l.plannerInfo).length > 0);

    let count = 0;
    for (let at of flatList) {
      const { plannerInfo } = at;
      if (plannerInfo[date]) {
        count += 1;
      }
      if (count === limit) {
        return false;
      }
    }
    return true;
  };
  handleDateClick = (date) => {
    const { selectedAssetId, groupedTests, assetsAllowedPerDay } = this.state;
    if (selectedAssetId && !this.checkIfMoreAssetsCanBeAdded(groupedTests, date, assetsAllowedPerDay)) {
      ToastService.Error(`Max ${assetsAllowedPerDay} assets allowed per day`, "");
      return;
    }
    if (!selectedAssetId) {
      ToastService.Error("No Asset Selected!", "");
      return;
    }
    if (groupedTests[selectedAssetId].find((at) => at.plannerInfo && at.plannerInfo[date] && at.plannerInfo[date].enable)) {
      ToastService.Error("Asset already added in plan!", "");
      return;
    }

    let updatedAssetTests = groupedTests[selectedAssetId].map((at) => {
      let plannerInfo = at.plannerInfo ? { ...at.plannerInfo, [date]: { enable: true } } : { [date]: { enable: true } };
      return { ...at, plannerInfo, touched: true };
    });
    let updated = { ...groupedTests, [selectedAssetId]: updatedAssetTests };
    this.setState({
      groupedTests: updated,
      selectedAssetId: null,
      isChanged: true,
    });
  };
  handleRemoveScheduledAsset = (date, selectedAssetId) => {
    const { groupedTests } = this.state;
    let updatedAssetTests = groupedTests[selectedAssetId].map((at) => {
      let plannerInfo = { ...(at.plannerInfo || {}) };
      if (plannerInfo[date]) delete plannerInfo[date];
      return { ...at, plannerInfo, touched: true };
    });
    let updated = { ...groupedTests, [selectedAssetId]: updatedAssetTests };

    this.setState({
      groupedTests: updated,
      isChanged: true,
    });
  };

  confirmSchedulePlan = () => {
    this.openConfirmationDialog("Schedule Plan", "Are you sure you want to save plan?", this.handleSchedulePI, "Confirm", null);
  };

  handleSchedulePI = () => {
    const { groupedTests } = this.state;
    const { updateAssetTest } = this.props;
    let dataToSend = Object.values(groupedTests)
      .flat()
      .reduce((prev, curr) => {
        return [
          ...prev,
          ...(curr.touched
            ? [
                {
                  assetId: curr.assetId,
                  testCode: curr.testCode,
                  plannerInfo: curr.plannerInfo,
                },
              ]
            : []),
        ];
      }, []);

    this.setState({
      isChanged: false,
      confirmationDialog: null,
    });
    updateAssetTest({ assetTests: dataToSend }, "pISchedulerInfo");
  };
  getAssetStates = (asset) => {
    let assetStates = { dailyDue: false, nonCompliant: false, outOfUse: false };
    if (asset.assetStates) {
      const { nonCompliant } = asset.assetStates;
      if (nonCompliant) {
        assetStates.nonCompliant = true;
      }
      const dailyDueDate = asset.assetStates.dailyDue;
      const startOfDay = momentTz.tz("US/Eastern").startOf("day").format();
      const endOfDay = momentTz.tz("US/Eastern").endOf("day").format();
      assetStates.dailyDue = dailyDueDate >= startOfDay && dailyDueDate <= endOfDay ? false : true;
      assetStates.outOfUse = asset.assetStates.outOfUse;
    }
    return assetStates;
  };
  render() {
    const { groupedTests, assets, spinnerLoading, isChanged, workingDays, searchTerm, weekDays, mode, confirmationDialog } = this.state;
    const filteredAssetIds = this.getFilteredAssetIds();
    const sortedAssetIds = this.getSortedAssetIds(filteredAssetIds);
    let spinner = <SpinnerLoader spinnerLoading={spinnerLoading} />;
    return (
      <React.Fragment>
        {spinner}
        {confirmationDialog}
        <div className="mainContent" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ width: "100%" }}>
            <MenuFilter
              menuFilterApplied={this.filterLocations}
              handelMenuClickData={this.filterLocations}
              displayMenuAll={true}
              dataLoadedCallback={() => {}}
            />
          </div>
          {this.isAllowedToEdit && (
            <div style={{ paddingInline: "20px" }}>
              <ToggleButton
                options={["View", "Edit"]}
                onSelected={(value) => {
                  this.setState({ mode: value });
                }}
                value={mode}
              />
            </div>
          )}
          <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "20px" }}>
            <div style={{ width: "75%", display: "flex", flexDirection: "column", gap: "20px" }}>
              <div>
                <input
                  style={{
                    borderRadius: "7px",
                    marginLeft: "20px",
                    padding: "10px 10px",
                    border: "2px solid var(--nine)",
                    marginBlockEnd: "10px",
                  }}
                  placeholder={`Search Asset...`}
                  value={searchTerm}
                  onChange={this.handleSearchChange}
                />
              </div>
              <div className="cv_container">
                {sortedAssetIds.map((assetId) => {
                  const tests = groupedTests[assetId];
                  const asset = assets.find((a) => a._id === assetId);
                  if (!asset) return null;

                  const assetStates = this.getAssetStates(asset);
                  const assetInfo = this.getAssetInfo(asset);
                  const sortedTests = this.getTestList(tests);
                  const cardData = {
                    order: ["Asset Info", "Available Tests"],
                    assetStates,
                    data: {
                      "Asset Info": assetInfo,
                      "Available Tests": sortedTests,
                    },
                  };

                  return (
                    <Card
                      key={assetId}
                      data={cardData}
                      assetData={asset}
                      renderAvailableTestsAsList={true}
                      handleAssetView={this.handleAssetView}
                      isSelected={this.state.selectedAssetId === assetId}
                      onSelect={this.handleAssetSelect}
                      disableSelect={this.state.selectedAssetId !== null && this.state.selectedAssetId !== assetId}
                      showSelectButton={mode === "Edit" ? true : false}
                    />
                  );
                })}
              </div>
            </div>
            <div
              style={{
                width: "25%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "100vh",
                position: "sticky",
                top: "80px",
              }}
            >
              {mode === "Edit" && (
                <div
                  style={{
                    padding: "10px",
                    position: "sticky",
                    top: "0",
                    zIndex: 1000,
                  }}
                >
                  <button
                    disabled={!isChanged}
                    className={`schedule-btn ${!isChanged ? "disabled" : ""}`}
                    onClick={this.confirmSchedulePlan}
                    style={{ width: "100%" }}
                  >
                    Schedule Plan
                  </button>
                </div>
              )}

              <div style={{ flex: 1, overflowY: "auto", paddingBottom: "80px" }}>
                <CalendarPanel
                  workingDays={workingDays}
                  onDateClick={(date) => {
                    if (mode === "View") return;
                    this.handleDateClick(date);
                  }}
                  assetIdNameMap={this.createAssetIdNameMap(this.state.assets)}
                  onRemoveScheduledAsset={this.handleRemoveScheduledAsset}
                  groupedTests={groupedTests}
                  weekDays={weekDays}
                  showRemoveButtons={mode === "Edit" ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const getAssetTests = curdActions.getAssetTests;
const updateAssetTest = curdActions.updateAssetTest;
const getApplicationlookupss = curdActions.getApplicationlookupss;
const actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: { getAllInspectableAssets, getAssetTests, updateAssetTest, getApplicationlookupss },
};
const variables = {
  assetHelperReducer: {
    allInspectableUserAssets: [],
  },
  assetTestReducer: { assetTests: [] },
  applicationlookupsReducer: {
    applicationlookupss: [],
  },
};
const PiContainer = CRUDFunction(PIScheduler, "PIScheduler", actionOptions, variables, [
  "assetHelperReducer",
  "assetTestReducer",
  "applicationlookupsReducer",
]);
export default PiContainer;



// WEBPACK FOOTER //
// ./src/components/PiScheduler/index.jsx